module.exports = __webpack_public_path__ + "static/craft-2460eaff9bb6f3b1053355fe1c320bda.jpg";